import Dictionary from './Type';

const enDictionary: Dictionary = {
    or: 'or',
    and: 'and',
    greeting: 'Hello',
    userName: 'User',
    close: 'Close',
    welcomeBack: 'Welcome back!',
    welcome: 'Welcome!',
    loading: 'Loading...',
    language: 'Language',
    game: {
        self: 'Game',
        title: 'Hangman',
        singleplayer: 'Single player',
        multiplayer: 'Multi player',
        youWin: 'You win!',
        youLose: 'You lose!',
        theWordWas: 'The word was',
        chooseWord: 'Write the word',
        generateRandomWord: 'Generate random word',
        chooseLetter: 'Choose a letter',
        confirm: 'Confirm',
        clear: 'Clear',
        showHideWord: 'Show/Hide word',
        wrongLetters: 'Wrong letters',
        difficulty: 'Difficulty',
        chooseDifficulty: 'Select difficulty',
        start: 'Start',
        easy: 'Easy',
        medium: 'Medium',
        hard: 'Hard',
        placeholder: 'Word',
        type: "Type",
    },
};

export default enDictionary;
